/* eslint-disable prettier/prettier */
import React, { useEffect } from 'react'
import { IS_ZONA_JOBS } from '../../../../../constants'

// mixins
import { AdListadoGoogleConatiner } from './mixins'

const Ad = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      (window.adsbygoogle = window.adsbygoogle || []).push({})
    }
  }, [])

  if (IS_ZONA_JOBS) return null

  return (
    <AdListadoGoogleConatiner>
      <ins
        className="adsbygoogle"
        style={{ display: 'block', width: '728px', height: '90px', margin: '0 auto' }}
        data-ad-client="ca-pub-6635751356116235"
        data-ad-format="fluid"
        data-ad-slot="6181456546"
        data-ad-layout-key="-fb+5w+4e-db+86"
      ></ins>
    </AdListadoGoogleConatiner>
  )
}

export default Ad